<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :custom-class="isH5 ? 'h5-coupon-dialog' : 'coupon-dialog'"
    center
  >
    <div slot="title" class="dialog-title">
      <span class="title">我的优惠券</span>
      <p class="tips">仅展示与课程相关且在使用有效期内的优惠券</p>
    </div>
    <ul v-if="couponList.length">
      <li v-for="item in couponList" :key="item.coupon_id" class="coupon-item">
        <div class="coupon-left">
          <p class="title">{{ item.coupon_name }}</p>
          <p class="time">
            {{ moment(item.use_start_time * 1000).format("YYYY-MM-DD HH:mm") }}
            至
            {{ moment(item.use_end_time * 1000).format("YYYY-MM-DD HH:mm") }}
          </p>
        </div>
        <div class="coupon-right">
          <p v-if="item.coupon_type === 1" class="face-value">
            ￥{{ item.amount / 100 }}
          </p>
          <p v-if="item.coupon_type === 2" class="face-value">
            {{ item.ratio / 10 }}折
          </p>
          <el-button
            type="primary"
            class="coupon-btn"
            @click="selectCoupon(item)"
            >立即使用</el-button
          >
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      description="暂无优惠券"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelCoupon">不用券</el-button>
      <el-button size="small" @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { getCouponList } from "@saas/server-api/src/coupon";
import moment from "moment";
export default {
  data: function () {
    return {
      moment,
      dialogVisible: false,
      activeId: "",
      couponList: [],
      isH5: isH5(),
    };
  },
  methods: {
    cancelCoupon() {
      this.$emit("selectCoupon", {});
      this.handleClose();
    },
    selectCoupon(item) {
      this.activeId = item.coupon_id;
      this.$emit("selectCoupon", item);
      this.handleClose();
    },
    handleClose() {
      this.activeId = "";
      this.couponList = [];
      this.dialogVisible = false;
    },
    openDialog(course_id) {
      this.getList(course_id);
      this.dialogVisible = true;
    },
    getList(course_id) {
      getCouponList({
        course_ids: course_id,
        page_no: 1,
        page_size: 99,
      }).then((res) => {
        const { code, data, message } = res;
        if (code === 1) {
          this.couponList = data.list || [];
        } else {
          this.$message.error(message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .coupon-dialog {
  width: 550px;
}
.coupon-dialog {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  .dialog-title {
    .title {
      line-height: 24px;
      font-size: 18px;
    }
    .tips {
      margin-top: 10px;
      color: #909399;
      text-align: center;
      font-size: 14px;
    }
  }

  .coupon-item {
    width: 500px;
    height: 113px;
    background: url("../../../assets/images/coupon-bg.png");
    background-size: 100% 100%;
    margin: 0 auto 10px;
    padding: 24px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .coupon-left {
      width: 305px;
    }
    .title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .time {
      font-size: 14px;
      color: #666666;
    }
    .coupon-right {
      text-align: center;
      .face-value {
        font-weight: normal;
        font-size: 18px;
        color: $chiral-price-color;
        margin-bottom: 9px;
        font-weight: 600;
      }
      .coupon-btn {
        width: 90px;
        height: 40px;
        background: $activity-color;
        border-radius: 20px;
        font-weight: 500;
        font-size: 15px;
        color: #ffffff;
        border: none;
        padding: 0;
        line-height: 40px;
      }
      .coupon-btn.el-button:hover,
      .coupon-btn.el-button:focus {
        background: $activity-color !important;
        border-color: $activity-color !important;
        color: #fff;
      }
    }
  }
  .active-item {
    box-shadow: 1px 5px 10px rgb(81, 3, 42);
  }
}

// 适配
::v-deep .h5-coupon-dialog {
  width: 100%;
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  min-height: 60%;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    padding: 0.27rem 0.21rem;
    flex: 1;
  }
  .el-dialog__footer {
    padding-top: 0;
  }
  .el-dialog__header {
    padding: 0.27rem;
  }
}
.h5-coupon-dialog {
  .dialog-title {
    .title {
      line-height: 24px;
      font-size: 18px;
    }
    .tips {
      margin-top: 10px;
      color: #909399;
      text-align: center;
      font-size: 14px;
    }
  }
  .coupon-item {
    width: 9.17rem;
    height: 2.48rem;
    background: url("../../../assets/images/coupon-bg.png");
    background-size: 100% 100%;

    padding: 0.41rem 0.33rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 0.4rem;
    .coupon-left {
      width: 5.73rem;
    }
    .title {
      font-size: 0.37rem;
      line-height: 0.53rem;
      font-weight: 500;
      margin-bottom: 0.11rem;
    }
    .time {
      font-size: 0.27rem;
      color: #666666;
      line-height: 0.48rem;
    }

    .coupon-right {
      text-align: center;
      .face-value {
        font-weight: normal;
        font-size: 0.64rem;
        color: $chiral-price-color;
        line-height: 0.64rem;
        margin-bottom: 0.21rem;
      }
      .coupon-btn {
        width: 1.87rem;
        height: 0.64rem;
        background: $activity-color;
        border-radius: 0.32rem;
        font-weight: 500;
        font-size: 0.35rem;
        color: #ffffff;
        border: none;
        padding: 0;
        line-height: 0.64rem;
      }
      .coupon-btn.el-button:hover,
      .coupon-btn.el-button:focus {
        background: $activity-color !important;
        border-color: $activity-color !important;
        color: #fff;
      }
    }
  }
  .active-item {
    box-shadow: 0.03rem 0.13rem 0.21rem rgb(81, 3, 42);
  }
}
</style>
<style>
.dialog-fade-enter-active .h5-coupon-dialog {
  animation: anim-open 0.3s !important;
}
.dialog-fade-leave-active .h5-coupon-dialog {
  animation: anim-close 0.3s !important;
}

@keyframes anim-open {
  0% {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes anim-close {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }
}
</style>
